import React, { Component } from "react";
import "./EditScorecardQuestionaries.css";
import { Sidebar, Header } from "..";
import EndpointConstant from "./../../constants/EndpointConstant";
import MessageConstant from "./../../constants/MessageConstant";
import utils from "./../../utils";
import CommonService from "../../commonService/CommonService";
import PopupModels from "../PopupModels/PopupModels";
import {
  Accordion,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Button,
} from "react-bootstrap";
import ConfirmationModal from "../PopupModels/ConfirmationModal";
import PropTypes from "prop-types";

class EditScorecardQuestionaries extends Component {
  constructor() {
    super();
    this.state = {
      scorecardQuestionDetails: [],
      numericWeightage: [],
      thresholdValue: 0,
      defaultQuesionDetails: [
        {
          id: 1,
          question: "",
          options: {},
          type: "",
          isEditable: false,
          isNew: true,
          numericWeightage: "",
        },
      ],
      extractValidation: false,
      extractErrMsg: "",
      accordionCollapse: "0",
      textMaxLength: "500",
      questionariesSuccessModel: false,
      isEdit: false,
      isDelete: false,
      activeAccordion: 0,
      addClass: false,
      classId: "",
      isEditable: false,
      show: false,
      qid: "",
      questionDetail: "",
      showDeleteConfirmation: false,
      showCloneConfirmation: false,
      questionSetName: "",
      questionSetDetails: {},
      isNewSet: false,
      questionsetShow: false,
      isEditQuestionsetSuccess: false,
      isEditClick: false,
      isQuestionNew: false,
      isClone: false,
      isSubmit: false,
      showModal: false,
      modalMessage: "",
    };

    this.getScoreCardQuestionarieList =
      this.getScoreCardQuestionarieList.bind(this);
    this.addQuestionOptions = this.addQuestionOptions.bind(this);
    this.updateOptionsValue = this.updateOptionsValue.bind(this);
    this.handleDeleteOption = this.handleDeleteOption.bind(this);
    this.handleAddQuestion = this.handleAddQuestion.bind(this);
    // this.handleEditQuestion = this.handleEditQuestion.bind(this);
    this.handleDeleteQuestion = this.handleDeleteQuestion.bind(this);
    // this.handleSubmitQuestion = this.handleSubmitQuestion.bind(this);
    this.handleExtractValidationClose =
      this.handleExtractValidationClose.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.saveId = this.saveId.bind(this);
    this.deletePopup = this.deletePopup.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
    this.handleOnChangeInput1 = this.handleOnChangeInput1.bind(this);
    this.handleSubmitQuestionSet = this.handleSubmitQuestionSet.bind(this);
  }

  componentDidMount() {
    if (Object.keys(this.props.questionDetails).length) {
      const groupedSectionQuestions = {}
      this.props.questionDetails.questionaries.forEach(question => {
        if (question.questionSectionType) {
          if (!groupedSectionQuestions[question.questionSectionType]) groupedSectionQuestions[question.questionSectionType] = [];
          groupedSectionQuestions[question.questionSectionType].push(question);
        }
        else {
          if (!groupedSectionQuestions['0']) groupedSectionQuestions['0'] = [];
          groupedSectionQuestions['0'].push(question);
        }
      })
      // console.log('groupedSectionQuestions', groupedSectionQuestions)
      this.setState({
        scorecardQuestionDetails: this.getQuestions(
          this.props.questionDetails.questionaries
        ),
        groupedSectionQuestions: groupedSectionQuestions,
        questionSetName: this.props.questionDetails.questionsetName,
        numericWeightage: this.getnumericWeightage(this.props.questionDetails),
        thresholdValue: this.props.questionDetails.thresholdValue ? this.props.questionDetails.thresholdValue : 0,
        questionSetDetails: this.props.questionDetails,
        questionsetShow: true,
        isQuestionNew: false,
      });
    } else {
      this.setState({
        scorecardQuestionDetails: this.state.defaultQuesionDetails,
        isQuestionNew: true,
        numericWeightage: this.state.numericWeightage,
        thresholdValue: this.state.thresholdValue,
      });
    }
  }

  getScoreCardQuestionarieList() {
    let data = {};
    let self = this;
    utils.makeRequest(
      this,
      EndpointConstant.SCORECARD_QUESTIONARIE_LIST,
      data,
      function (result) {
        utils.hideLoader();
        if (result.error === false) {
          self.loading = false;
          const questions =
            result.Questionaries.length === 0
              ? self.state.defaultQuesionDetails
              : self.getQuestions(result.Questionaries);
          self.setState({
            scorecardQuestionDetails: questions,
          });
        }
      }
    );
  }

  getQuestions(questionaries) {
    return questionaries.map((val, i) => {
      return {
        id: val.id ? val.id : ++i,
        question: val.question,
        options: val.options ? val.options : {},
        type: val.type,
        weightage: val.weightage ? val.weightage : "",
        isEditable: true,
        isNew: false,
        numericWeightage: val.numericWeightage ? val.numericWeightage : "0",
        questionSectionType: val.questionSectionType ? val.questionSectionType : "",
      };
    });
  }


  getnumericWeightage(questionDetails) {
    if (questionDetails.numericWeightage === undefined) {
      const numericWeightage = new Array(questionDetails.questionaries.length).fill(0)
      return numericWeightage
    }
    return questionDetails.numericWeightage
  }

  hideModal = () => {
    this.setState({ showModal: false });
  };

  updateQuestion(isQuestion, questionId, e) {
    const value = parseFloat(e.target.value) || 0;
    const questions = this.state.scorecardQuestionDetails;
    const newWeights = Array.isArray(this.state.numericWeightage)
      ? this.state.numericWeightage
      : [];
    if (isQuestion) {
      questions[questionId].question = e.target.value;
    } else {
      if (e.target.name === "questionSectionType") {
        // console.log("Debug: questionSectionType changed to", e.target.value);
        questions[questionId].questionSectionType = e.target.value;
      }
      else if (e.target.name === "weightage") {
        questions[questionId].weightage = e.target.value;
      } else if (e.target.value === "Text" || e.target.value === "Y/N") {
        questions[questionId].type = e.target.value;
        questions[questionId].options = {};
      } else if (e.target.name === "numberInput") {
        if (value > 100) {
          this.setState({
            extractValidation: true,
            extractErrMsg: "Weight should not be greater than 100",
          });
          return false;
        } else if (value < 0) {
          this.setState({
            extractValidation: true,
            extractErrMsg: "Weight should not be less than 0",
          });
          return false;
        }

        // console.log("Updated question row:", questions[questionId]);

        questions[questionId].numericWeightage = e.target.value;
        newWeights[questionId] = parseInt(
          questions[questionId].numericWeightage
        );
        const total = newWeights.reduce((a, b) => a + b, 0);
        if (total > 100) {
          this.setState({
            extractValidation: true,
            extractErrMsg: "Total weightage should not exceed 100",
          });
          return false;
        }
        this.setState({ numericWeightage: newWeights });
      } else {
        questions[questionId].type = e.target.value;
        questions[questionId].options = {};
      }
    }
    this.setState({
      scorecardQuestionDetails: questions,
    });
  }
  handleOnChangeInput1(e) {
    const { value } = e.target;
    if (value >= 0 && value <= 100) {
      this.setState({
        thresholdValue: e.target.value,
      });
    }
  }

  percentExtract(data) {
    switch (data) {
      case "minus":
        this.setState((p) => {
          let thresholdValue = parseInt(p.thresholdValue) - 1;
          if (thresholdValue <= 0) return (p.thresholdValue = 1);
          else return (p.thresholdValue = thresholdValue);
        });
        break;
      case "plus":
        this.setState((p) => {
          let thresholdValue = parseInt(p.thresholdValue) + 1;
          if (thresholdValue > 100) return (p.thresholdValue = 100);
          else return (p.thresholdValue = thresholdValue);
        });
        break;
      default:
        break;
    }
  }

  addQuestionOptions(QuestionRowId) {
    let options = this.state.scorecardQuestionDetails;
    // eslint-disable-next-line
    const optionsLength = Object.keys(options[QuestionRowId].options).length
      ? parseInt(Object.keys(options[QuestionRowId].options).pop())
      : Object.keys(options[QuestionRowId].options).length;
    options[QuestionRowId].options = {
      ...options[QuestionRowId].options,
      [optionsLength + 1]: "",
    };
    this.setState({
      scorecardQuestionDetails: [...options],
    });
  }

  updateOptionsValue(e, questionIndex, optionIndex) {
    let optionDetails = this.state.scorecardQuestionDetails;
    optionDetails[questionIndex].options[optionIndex] = e.target.value;
    this.setState({
      scorecardQuestionDetails: optionDetails,
    });
  }

  handleDeleteOption(questionRow, deleteOption) {
    const optionDetail = this.state.scorecardQuestionDetails;
    delete optionDetail[questionRow].options[deleteOption];
    this.setState({
      scorecardQuestionDetails: optionDetail,
    });
  }

  handleAddQuestion(index) {
    let existingQuestions = this.state.scorecardQuestionDetails;
    let newWeights = this.state.numericWeightage;
    const total = newWeights.reduce((a, b) => a + b, 0);
    if (total >= 100) {
      this.setState({
        showModal: true,
        modalMessage:
          "The weight percentage reached maximum limit try reducing the weight percentage",
      });
    }
    const newQuestion = {
      id: existingQuestions.length + 1,
      isEditable: false,
      question: "",
      options: {},
      type: "",
      isNew: true,
      numericWeightage: "",
    };
    existingQuestions.splice(++index, 0, newQuestion);
    newWeights.splice(index, 0, 0)
    this.setState({
      scorecardQuestionDetails: existingQuestions,
      numericWeightage: newWeights
    });
    this.toggle(true);
  }

  deletePopup(qid, questionDetail) {
    const updatedQuestions = [...this.state.scorecardQuestionDetails];
    updatedQuestions.splice(qid, 1);

    if (updatedQuestions.length === 0) {
      updatedQuestions.push({
        id: 1,
        question: "",
        options: {},
        type: "",
        isEditable: false,
        isNew: true,
        numericWeightage: "",
      });
    }

    this.setState({
      scorecardQuestionDetails: updatedQuestions,
      numericWeightage: this.state.numericWeightage.filter((_, i) => i !== qid),
      isEditClick: true,
      isQuestionNew: true,
    });
  }
  clonePopup() {
    this.setState({ showCloneConfirmation: true });
  }

  hideDeletePopup() {
    this.setState({
      qid: "",
      questionDetail: "",
      showDeleteConfirmation: false,
    });
  }

  hideClonePopup() {
    this.setState({ showCloneConfirmation: false });
  }

  handleDeleteQuestion(qid, questionDetail) {
    let currentWeights = this.state.numericWeightage;
    Array.isArray(currentWeights)
      ? currentWeights.splice(qid, 1)
      : currentWeights;
    this.setState({ numericWeightage: currentWeights });
    const existingQuestions = this.state.scorecardQuestionDetails;
    if (!questionDetail.isNew) {
      // apicall
      let data = {};
      let self = this;
      let newQuestions = [];
      const requesData = this.state.scorecardQuestionDetails;
      // const question =  requesData.map(({ isEditable,isNew, ...item }) => item);
      const question = [];
      requesData.splice(qid, 1);
      requesData.forEach((val, i) => {
        if (val.isNew) {
          newQuestions.push({ id: i + 1, question: val });
        } else {
          question.push({
            id: val.id,
            options: val.options,
            question: val.question,
            type: val.type,
            weightage: val.weightage,
            numericWeightage: val.numericWeightage,
            questionSectionType: val.questionSectionType,
          });
        }
      });
      if (self.state.isClone) {
        this.setState({
          scorecardQuestionDetails: requesData,
          isDelete: true,
          showDeleteConfirmation: false,
          questionariesSuccessModel: true,
        });
      } else {
        data = {
          id: this.state.questionSetDetails.id,
          questionsetName: this.state.questionSetName,
          questionaries: question,
          numericWeightage: this.state.numericWeightage,
          thresholdValue: this.state.thresholdValue,
        };
        utils.makeRequest(
          this,
          EndpointConstant.EDIT_SCORECARD_QUESTIONARIE,
          data,
          function (result) {
            if (result.error === false) {
              self.loading = false;
              const questionSetId = data.id
                ? data.id
                : result.Questionaries[0].id;
              const getCurrentQuestionSet = result.Questionaries.length
                ? result.Questionaries.filter((val) => val.id === questionSetId)
                : [];
              const questions =
                getCurrentQuestionSet.length === 0
                  ? self.state.defaultQuesionDetails
                  : self.getQuestions(getCurrentQuestionSet[0].questionaries);
              newQuestions.forEach((val) => {
                questions.splice(val.id - 1, 0, val.question);
              });
              self.setState({
                showDeleteConfirmation: false,
                isDelete: true,
                questionariesSuccessModel: true,
                scorecardQuestionDetails: questions,
                // show: true,
                classId: 1,
                isNewSet: !Object.keys(self.props.questionDetails).length
                  ? true
                  : false,
                questionSetDetails: !Object.keys(self.props.questionDetails)
                  .length
                  ? result.Questionaries[0]
                  : self.props.questionDetails,
                isQuestionNew: false,
              });
            }
          }
        );
      }
    } else {
      existingQuestions.splice(qid, 1);
      this.setState({
        scorecardQuestionDetails: existingQuestions,
        isDelete: true,
        showDeleteConfirmation: false,
        questionariesSuccessModel: true,
        // show: true,
      });
      this.toggle(true);
    }
  }

  handleEditQuestion() {
    const existingQuestion = [];
    this.state.scorecardQuestionDetails.forEach((val) => {
      val.isEditable = false;
      existingQuestion.push(val);
    });
    this.setState({
      scorecardQuestionDetails: existingQuestion,
      isEditable: !this.state.isEditable,
      // classId: '',
      // show: false,
      // show: true,
      isEditClick: true,
      isQuestionNew: true,
    });
    this.toggle(true);
  }

  handleCloneQuestion() {

    const existingQuestion = [];
    this.state.scorecardQuestionDetails.forEach((val) => {
      val.isEditable = false;
      existingQuestion.push(val);
    });
    this.setState({
      questionSetName: this.addCopy(this.state.questionSetName),
      scorecardQuestionDetails: existingQuestion,
      isEditable: !this.state.isEditable,
      isClone: true,
      questionsetShow: !this.state.questionsetShow,
      isEditClick: true,
      isQuestionNew: true,
      showCloneConfirmation: false,
      questionariesSuccessModel: false,
    });
    this.toggle(true);
  }

  handleExtractValidationClose() {
    this.setState({
      extractValidation: false,
      extractErrMsg: "",
    });
  }

  handleSubmitQuestion() {
    const questionSetName = this.state.questionSetName;
    if (!this.checkQuestionsetValidation(questionSetName)) {
      return;
    }

    const requesData = this.state.scorecardQuestionDetails;
    for (let qid = 0; qid < requesData.length; qid++) {
      if (!this.checkValidation(qid, requesData[qid])) {
        return;
      }
    }

    if(!this.checkCaseSection()){
      return;
    }

    if(!this.checkPassingScoreValidation()){
      return;
    }

    let data = {};
    let endpointName = "";
    let self = this;
    const question = [];
    let isError = false;
    this.state.scorecardQuestionDetails.forEach((questionDetail, qid) => {
      if (this.checkValidation(qid, questionDetail)) {
        if (questionDetail.isNew) {
          question.push({
            options: questionDetail.options,
            question: questionDetail.question,
            type: questionDetail.type,
            weightage: questionDetail.weightage,
            numericWeightage: questionDetail.numericWeightage,
            questionSectionType: questionDetail.questionSectionType,
          });

        } else {
          question.push({
            id: questionDetail.id,
            options: questionDetail.options,
            question: questionDetail.question,
            type: questionDetail.type,
            weightage: questionDetail.weightage,
            numericWeightage: questionDetail.numericWeightage,
            questionSectionType: questionDetail.questionSectionType,
          });
          // console.log("Submitting question:", questionDetail);

        }


        // let data = {}
        // let endpointName = '';
        // let self = this;
        // let newQuestions = [];
        // const requesData = this.state.scorecardQuestionDetails;
        // const question = [];
        // requesData.forEach((val, i) => {
        //   if (val.isNew) {
        //     if (i + 1 === qid + 1) {
        //       question.push({ options: val.options, question: val.question, type: val.type });
        //     } else {
        //       newQuestions.push({id: i+1, question: val})
        //     }
        //   } else {
        //     question.push({ id: val.id, options: val.options, question: val.question, type: val.type });
        //   }
        // });
        // if (Object.keys(this.props.questionDetails).length) {
        //   //call Edit
        //   data = { id: this.state.questionSetDetails.id, questionsetName: this.state.questionSetName, questionaries: question };
        //   endpointName = EndpointConstant.EDIT_SCORECARD_QUESTIONARIE;
        // } else if (!this.state.isNewSet) {
        //   // call add
        //   data = { questionsetName: this.state.questionSetName, questionaries: question };
        //   endpointName = EndpointConstant.ADD_SCORECARD_QUESTIONARIE;
        // } else {
        //   data = { id: this.state.questionSetDetails.id, questionsetName: this.state.questionSetName, questionaries: question };
        //   endpointName = EndpointConstant.EDIT_SCORECARD_QUESTIONARIE;
        // }
        //   utils.makeRequest(this, endpointName, data, function (result) {
        //     if (result.error === false) {
        //       self.loading = false;
        //       const questionSetId = data.id ? data.id : result.Questionaries[0].id;
        //       const getCurrentQuestionSet = result.Questionaries.length ? result.Questionaries.filter(val => val.id === questionSetId) : [];
        //       const questions = getCurrentQuestionSet.length === 0 ? self.state.defaultQuesionDetails : self.getQuestions(getCurrentQuestionSet[0].questionaries);
        //       newQuestions.forEach(val => {
        //         questions.splice((val.id-1), 0, val.question)
        //       })

        //       self.setState({
        //         scorecardQuestionDetails: questions,
        //         questionSetName: getCurrentQuestionSet.length ? getCurrentQuestionSet[0].questionsetName : self.state.questionSetName,
        //         questionariesSuccessModel: true,
        //         show: true,
        //         classId: 1,
        //         isEdit: endpointName === EndpointConstant.ADD_SCORECARD_QUESTIONARIE ? true : false,
        //         isNewSet: !Object.keys(self.props.questionDetails).length ? true : false,
        //         questionSetDetails: !Object.keys(self.props.questionDetails).length ? result.Questionaries[0] : self.props.questionDetails,
        //         isDelete: false,
        //         questionsetShow: true
        //       })
        //     }
        //   })
      }
      // if (!this.checkTotalValidation()) {  
      //   return;
      // }      
      else {
        isError = true;
      }
    }
    );    
    if (!this.checkTotalValidation()) {
      return;
    }

    if (!isError) {
      if (Object.keys(this.props.questionDetails).length) {
        if (!this.state.isClone) {
          //call Edit
          data = {
            id: this.state.questionSetDetails.id,
            questionsetName: this.state.questionSetName.trim(),
            questionaries: question,
            thresholdValue: this.state.thresholdValue,
            numericWeightage: this.state.numericWeightage,
          };
          endpointName = EndpointConstant.EDIT_SCORECARD_QUESTIONARIE;
        } else {
          if (!self.state.isSubmit) {
            // call add
            data = {
              questionsetName: this.state.questionSetName.trim(),
              questionaries: question,
              thresholdValue: this.state.thresholdValue,
              numericWeightage: this.state.numericWeightage,
            };
            endpointName = EndpointConstant.ADD_SCORECARD_QUESTIONARIE;
          } else {
            //call Edit
            data = {
              id: this.state.questionSetDetails.id,
              questionsetName: this.state.questionSetName.trim(),
              questionaries: question,
              thresholdValue: this.state.thresholdValue,
              numericWeightage: this.state.numericWeightage,
            };
            endpointName = EndpointConstant.EDIT_SCORECARD_QUESTIONARIE;
          }
        }
      } else if (!this.state.isSubmit) {
        // call add
        data = {
          questionsetName: this.state.questionSetName.trim(),
          questionaries: question,
          thresholdValue: this.state.thresholdValue,
          numericWeightage: this.state.numericWeightage,
        };
        endpointName = EndpointConstant.ADD_SCORECARD_QUESTIONARIE;
      } else {
        data = {
          id: this.state.questionSetDetails.id,
          questionsetName: this.state.questionSetName.trim(),
          questionaries: question,
          thresholdValue: this.state.thresholdValue,
          numericWeightage: this.state.numericWeightage,
        };
        endpointName = EndpointConstant.EDIT_SCORECARD_QUESTIONARIE;
      }

      utils.makeRequest(this, endpointName, data, function (result) {
        if (result.error === false) {
          self.loading = false;
          const questionSetId = data.id ? data.id : result.Questionaries[0].id;
          const getCurrentQuestionSet = result.Questionaries.length
            ? result.Questionaries.filter((val) => val.id === questionSetId)
            : [];
          const questions =
            getCurrentQuestionSet.length === 0
              ? self.state.defaultQuesionDetails
              : self.getQuestions(getCurrentQuestionSet[0].questionaries);
          const groupedSectionQuestions = {}
          questions.forEach(question => {
            if (question.questionSectionType) {
              if (!groupedSectionQuestions[question.questionSectionType]) groupedSectionQuestions[question.questionSectionType] = [];
              groupedSectionQuestions[question.questionSectionType].push(question);
            }
            else {
              if (!groupedSectionQuestions['0']) groupedSectionQuestions['0'] = [];
              groupedSectionQuestions['0'].push(question);
            }
          })
          self.setState({
            scorecardQuestionDetails: questions,
            groupedSectionQuestions: groupedSectionQuestions,
            questionSetName: getCurrentQuestionSet.length
              ? getCurrentQuestionSet[0].questionsetName.trim()
              : self.state.questionSetName.trim(),
            questionariesSuccessModel: true,
            // show: true,
            isEdit:
              endpointName === EndpointConstant.ADD_SCORECARD_QUESTIONARIE
                ? true
                : false,
            isNewSet: !Object.keys(self.props.questionDetails).length
              ? true
              : false,
            questionSetDetails: self.state.isClone
              ? Object.keys(self.props.questionDetails).length
                ? result.Questionaries[0]
                : self.props.questionDetails
              : !Object.keys(self.props.questionDetails).length
                ? result.Questionaries[0]
                : self.props.questionDetails,
            isDelete: false,
            questionsetShow: true,
            isQuestionNew: false,
            isSubmit: true,
            isEditClick: false
          });
        }
      });
    }
  }

  checkValidation(qid, questionDetail) {    
    if (
      questionDetail.type === "SingleSelect" ||
      questionDetail.type === "MultiSelect"
    ) {
      let checkDuplicateOption = Object.values(questionDetail.options);
      if (
        checkDuplicateOption.some(
          (val, index) => checkDuplicateOption.indexOf(val) !== index
        )
      ) {
        this.setState({
          extractValidation: true,
          extractErrMsg: "Options should not contain duplicate values",
        });
        return false;
      } else if (
        !Object.keys(questionDetail.options).length ||
        !questionDetail.options[Object.keys(questionDetail.options).shift()] ||
        checkDuplicateOption.some((val) => !val)
      ) {
        this.setState({
          extractValidation: true,
          extractErrMsg: "Options should not be empty",
        });
        return false;
      }
    }

    if (
      this.state.scorecardQuestionDetails.some(
        (val) =>
          val.question.length &&
          questionDetail.question.length &&
          questionDetail.question.toLowerCase().trim() ===
          val.question.toLowerCase() &&
          val.id !== questionDetail.id
      )
    ) {
      this.setState({
        extractValidation: true,
        extractErrMsg:
          "Question name already exist. Please enter unique question name",
      });
      return false;
    }

    if (!questionDetail.question.length) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Question field should not be empty",
      });
      return false;
    }
    if (!questionDetail.type) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Question type field should not be empty",
      });
      return false;
    }
    if (!questionDetail.weightage) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Criticality field should not be empty",
      });
      return false;
    }
    if (!questionDetail.numericWeightage.length || questionDetail.numericWeightage === "") {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Numeric weightage field should not be empty",
      });
      return false;
    }
    if (!questionDetail.questionSectionType) {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Case section field should not be empty",
      });
      return false;
    }    
    return this.checkQuestionsetValidation();
  }

  checkQuestionsetValidation() {


    // console.log("this.state.questionSetName", this.state.questionSetName);
    // console.log("Debug: QuestionSetName =", this.state.questionSetName);

    // if (!this.state.questionSetName.length) {
    //   this.setState({
    //     extractValidation: true,
    //     extractErrMsg: "Questionset name field should not be empty",
    //   });
    //   return false;
    // }

    if (!this.state.questionSetName || this.state.questionSetName.trim() === "") {
      console.warn("Warning: questionSetName is empty or undefined");
      this.setState({
        extractValidation: true,
        extractErrMsg: "Questionset name field should not be empty",
      });
      return false;
    }

    if (this.state.isClone) {
      if (
        this.props.scorecardQuestionDetails.length &&
        this.props.scorecardQuestionDetails.some(
          (val) =>
            val.questionsetName.toLowerCase() ===
            this.state.questionSetName.toLowerCase().trim()
        )
      ) {
        this.setState({
          extractValidation: true,
          extractErrMsg:
            "Questionset name already exist. Please enter unique questionset name",
        });
        return false;
      }
    } else if (
      this.props.scorecardQuestionDetails.length &&
      this.props.scorecardQuestionDetails.some(
        (val) =>
          val.questionsetName.toLowerCase() ===
          this.state.questionSetName.toLowerCase().trim() &&
          val.id !== this.state.questionSetDetails.id
      )
    ) {
      this.setState({
        extractValidation: true,
        extractErrMsg:
          "Questionset name already exist. Please enter unique questionset name",
      });
      return false;
    }
    return true;
  }

  checkTotalValidation() {
    const a = this.state.scorecardQuestionDetails.some((a) => a.numericWeightage === "")
    if (!a) {
      let weights = Array.isArray(this.state.numericWeightage)
        ? this.state.numericWeightage
        : [];
      const total = weights.reduce((a, b) => a + b, 0);
      if (total !== 100) {
        this.setState({
          extractValidation: true,
          extractErrMsg: "Total weightage must be exactly 100",
        });
        return false;
      }
    }
    return true;
  }

  checkPassingScoreValidation(){
    const thresholdValue = this.state.thresholdValue
    if(thresholdValue <= 0 || thresholdValue > 100 || thresholdValue == '') {
      this.setState({
        extractValidation: true,
        extractErrMsg: "Passing score must be between 1 and 100",
      });
      return false;
    }
    return true;
  }

  checkCaseSection() {
    //Required case section types 
    const requiredTypes = [
      "Master Case Details",
      "Response Details",
      "MI Sub Case Details",
      "MI Inquiry Details"
    ];
    const questionaries = this.state.scorecardQuestionDetails

    //Get all case section types from the array
    const questionSectionTypes = new Set(
      questionaries.map(item => item.questionSectionType)
    );
    // console.log("Question Section Types:", questionSectionTypes);

    // Find which required case section types are missing
    const missingQuestionSectionTypes = requiredTypes.filter(type => !questionSectionTypes.has(type));

    if (missingQuestionSectionTypes.length > 0) {
      const formattedList = missingQuestionSectionTypes.length === 1
        ? `"${missingQuestionSectionTypes[0]}"`
        : missingQuestionSectionTypes.length === 2
          ? `"${missingQuestionSectionTypes[0]}" and "${missingQuestionSectionTypes[1]}"`
          : `"${missingQuestionSectionTypes.slice(0, -1).join('", "')}", and "${missingQuestionSectionTypes.slice(-1)}"`;

      this.setState({
        extractValidation: true,
        extractErrMsg: `The ${formattedList} case section${missingQuestionSectionTypes.length > 1 ? 's' : ''} currently do${missingQuestionSectionTypes.length > 1 ? '' : 'es'} not contain any questions. Please ensure that at least one question is added before proceeding with the Save`
      });
      return false;
    }
    return true;
  }


  handlePopupClose() {
    this.setState({
      isEdit: false,
      questionariesSuccessModel: false,
      isEditable: !this.state.isEditable,
      isEditQuestionsetSuccess: false,
      classId: 1,
      // show: true
    });
    this.toggle(true);
  }
  toggle(show = false) {
    // this.setState({addClass: !this.state.addClass});
    let isShow = typeof show === "boolean" && show ? show : this.state.show;
    if (this.state.classId !== "" && isShow) {
      const existingQuestion = this.state.scorecardQuestionDetails;
      if (
        this.state.classId !== "" &&
        existingQuestion[this.state.classId - 1]
      ) {
        var element = document.getElementById(this.state.classId);
        if (element && Object.values(element.classList).includes("show")) {
          element.classList.remove("show");
        }
      }
    }
  }

  saveId(e, isEditable) {
    this.setState({ classId: e, isEditable: isEditable });
  }

  goBack() {
    // this.props.hideViewDetails();
    window.location.reload(false);
  }

  // handleOnChangeInput(e) {
  //   e.preventDefault();
  //   this.setState({
  //     questionSetName: e.target.value,
  //   });
  // }
  handleOnChangeInput(e) {
    const value = e.target.value;

    this.setState({ questionSetName: value }, () => {
      // console.log("Updated questionSetName:", this.state.questionSetName);
    });
  }


  handleSubmitQuestionSet(value = "") {
    if (value === "edit") {
      this.setState({ questionsetShow: false, isSubmit: true });
      return;
    }

    if (!this.checkQuestionsetValidation()) {
      return;
    }

    const requesData = this.state.scorecardQuestionDetails;
    for (let qid = 0; qid < requesData.length; qid++) {
      if (!this.checkValidation(qid, requesData[qid])) {
        return;
      }
    }

    if(!this.checkCaseSection()){
      return;
    }

    if (!this.checkTotalValidation()) {
      return;
    }
    
    if(!this.checkPassingScoreValidation()){
      return;
    }

    const question = requesData
      .filter((val) => !val.isNew)
      .map((val) => ({
        id: val.id,
        options: val.options,
        question: val.question,
        type: val.type,
        weightage: val.weightage,
        numericWeightage: val.numericWeightage,
        questionSectionType: val.questionSectionType,
      }));

    const data = {
      id: this.state.questionSetDetails.id,
      questionsetName: this.state.questionSetName.trim(),
      questionaries: question,
      thresholdValue: this.state.thresholdValue,
      numericWeightage: this.state.numericWeightage,
    };

    utils.makeRequest(this, EndpointConstant.EDIT_SCORECARD_QUESTIONARIE, data, (result) => {
      if (result.error === false) {
        const getCurrentQuestionSet = result.Questionaries.filter(
          (val) => val.id === this.state.questionSetDetails.id
        );
        this.setState({
          questionsetShow: true,
          questionSetName: getCurrentQuestionSet[0].questionsetName,
          questionariesSuccessModel: true,
          isEditQuestionsetSuccess: true,
          isSubmit: true,
        });
      }
    });
  }


  add3Dots(string, limit) {
    string = string.filter((val) => !!val).join(",");
    string = string.length ? string : "Click here to add options";
    var dots = "...";
    if (string && string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }
    return string;
  }

  addCopy(string) {
    let substr = "Copy of ";
    if (string.includes(substr)) {
      if (string.indexOf(substr) == "0") {
        return string;
      } else {
        string = substr + string;
        return string;
      }
    } else {
      string = substr + string;
      return string;
    }
  }

  render() {
    let questionsetInfo;
    if (this.props.questionSetEditMode) {
      if (
        (Object.keys(this.props.questionDetails).length ||
          this.state.scorecardQuestionDetails.length) &&
        this.state.questionsetShow
      ) {
        questionsetInfo = (
          <div className="col-sm-12">
            <label className="" title={this.state.questionSetName}>
              {this.state.questionSetName}
            </label>
            <span
              className="pl-2"
              onClick={() => this.handleSubmitQuestionSet("edit")}
            >
              <img src="/Images/ico-edit.png" alt="Amgen" className="pb-2" />
            </span>
          </div>
        );
      } else if (
        (Object.keys(this.props.questionDetails).length ||
          this.state.isNewSet) &&
        this.state.isSubmit
      ) {
        questionsetInfo = (
          <div className="col-sm-12 row am-questions am-options">
            <Form.Control
              size="sm"
              type="text"
              name="questionSetName"
              value={this.state.questionSetName}
              onChange={this.handleOnChangeInput}
              disabled={this.state.questionsetShow}
              placeholder="Please enter name here"
              className="col-sm-3 am-question"
            />
            <span
              className="pl-2"
              onClick={() => this.handleSubmitQuestionSet()}
            >
              {" "}
              <img src="/Images/ico-approve.png" alt="Amgen" />
            </span>
          </div>
        );
      } else {
        questionsetInfo = (
          <Form.Control
            size="sm"
            type="text"
            name="questionSetName"
            value={this.state.questionSetName}
            onChange={this.handleOnChangeInput}
            disabled={!this.props.questionSetEditMode}
            placeholder="Please enter name here"
            className="col-md-4 am-options"
          />
        );
      }
    } else {
      questionsetInfo = <label>{this.state.questionSetName}</label>;
    }
    const a = this.state.scorecardQuestionDetails.map((c) => c.isEditable);

    return (
      <div>
        <Header />
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="menu-content" onClick={this.toggle.bind(this)}>
          <div className="row">
            <label className="question-style col-sm-12">Questionset</label>
            {questionsetInfo}
          </div>
          <div className="row">
            <label className="question-style col-sm-12">Questionnaires</label>
          </div>

          {!this.state.isEditClick && this.state.groupedSectionQuestions && Object.keys(this.state.groupedSectionQuestions).map(questionRow => {
            return (<div>
              <div className="row">
                <label className="question-style1 col-sm-12">{Number(questionRow) === 0 ? '' : questionRow}</label>
              </div>
              {this.state.groupedSectionQuestions[questionRow].map((question, index) => {
                return (
                  <div key={question.id} className="row am-questions">
                    <Form.Control
                      size="sm"
                      as="textarea"
                      disabled
                      placeholder="Please enter the question here"
                      name="question"
                      defaultValue={question.question}
                      className="col-md-3 am-question"
                      rows={2}
                    />
                    <Form.Control
                      as="select"
                      name="type"
                      size="sm"
                      placeholder="Choose question type"
                      className="col-md-2 am-question"
                      disabled
                      value={question.type}
                    >
                      {CommonService.questionType.map((type) => (
                        <option key={type.id} value={type.value}>
                          {type.name}
                        </option>
                      ))}
                    </Form.Control>
                    {question.type === "MultiSelect" ? (
                      <Accordion
                        defaultActiveKey={this.state.activeAccordion}
                        className="col-md-2 am-padding"
                        onClick={() =>
                          this.saveId(index + 1, question.isEditable)
                        }
                      >
                        <Card className="radius accordion-height">
                          <Accordion.Toggle
                            as={Card.Header}
                            eventKey="0"
                            className="noColor cardHead"
                          >
                            {Object.keys(question.options).length
                              ? this.add3Dots(
                                Object.values(question.options),
                                30
                              )
                              : "Click here to add options"}{" "}
                            <i className="fas fa-chevron-down downIcon"></i>
                          </Accordion.Toggle>

                          <Accordion.Collapse
                            eventKey="0"
                            id={index + 1}
                            className={"am-option-accordion"}
                          >
                            <Card.Body className="cardBodyStyle noColor">
                              <Form className="optionsForm">
                                {question.isEditable ? (
                                  ""
                                ) : (
                                  <Form.Row className="mb-2">
                                    <Col
                                      md={{ span: 3, offset: 9 }}
                                      className="text-center"
                                    >
                                      <a
                                        onClick={() =>
                                          this.addQuestionOptions(index)
                                        }
                                      >
                                        <i className="fa fa-plus"></i>&nbsp; Add
                                      </a>
                                    </Col>
                                  </Form.Row>
                                )}
                                {Object.keys(question.options).map((k) => {
                                  return (
                                    <Form.Row key={k} className="am-options">
                                      <Col md={10}>
                                        <Form.Control
                                          type="text"
                                          value={question.options[k]}
                                          disabled
                                          onChange={(e) =>
                                            this.updateOptionsValue(e, index, k)
                                          }
                                          maxLength={this.state.textMaxLength}
                                        ></Form.Control>
                                      </Col>
                                      {question.isEditable ? (
                                        ""
                                      ) : (
                                        <Col md={2}>
                                          <span
                                            className="delete-style am-questions"
                                            onClick={() =>
                                              this.handleDeleteOption(index, k)
                                            }
                                          >
                                            <img
                                              src="/Images/ico-delete.png"
                                              alt="delete-icon"
                                              className="image-padding"
                                            />
                                          </span>
                                        </Col>
                                      )}
                                    </Form.Row>
                                  );
                                })}
                              </Form>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    ) : question.type === "Y/N" ? (
                      <Form.Control
                        as="select"
                        className="col-md-2 am-question"
                        size="sm"
                        disabled
                      >
                        {CommonService.yesNoOption.map((type) => (
                          <option key={type.id} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                      </Form.Control>
                    ) : (
                      <Form.Control
                        type="text"
                        readOnly
                        className="col-md-2 am-question"
                        size="sm"
                      ></Form.Control>
                    )}

                    <Form.Control
                      as="select"
                      name="weightage"
                      size="sm"
                      placeholder="Choose criticality type"
                      className="col-md-2 am-question"
                      disabled
                      value={question.weightage ? question.weightage : ""}
                      onChange={(e) => this.updateQuestion(false, index, e)}
                    >
                      {CommonService.weightage.map((val) => (
                        <option
                          key={val.id}
                          value={val.value}
                          disabled={val.value === ""}
                          hidden={val.value === ""}
                        >
                          {val.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control
                      type="number"
                      name="numberInput"
                      size="sm"
                      placeholder="--Weightage--"
                      className="col-md-2 am-question"
                      disabled
                      value={
                        question.numericWeightage
                          ? question.numericWeightage
                          : ""
                      }
                      onChange={(e) => this.updateQuestion(false, index, e)}
                      min={0}
                      max={100}
                      step={1}
                    ></Form.Control>
                  </div>
                );
              })}
            </div>)
          })}
          {(this.state.isEditClick || this.state.isQuestionNew) && this.state.scorecardQuestionDetails.map((questionRow, index) => {
            return (
              <div key={questionRow.id} className="row am-questions">
                <Form.Control
                  size="sm"
                  as="textarea"
                  disabled={questionRow.isEditable ? true : false}
                  placeholder="Please enter the question here"
                  name="question"
                  defaultValue={questionRow.question}
                  className="col-md-3 am-question"
                  rows={2}
                  onChange={(e) => this.updateQuestion(true, index, e)}
                />
                <Form.Control
                  as="select"
                  name="type"
                  size="sm"
                  placeholder="Choose question type"
                  className="custom-col-1-5 am-question"
                  disabled={questionRow.isEditable ? true : false}
                  value={questionRow.type}
                  onChange={(e) => this.updateQuestion(false, index, e)}
                >
                  {CommonService.questionType.map((type) => (
                    <option key={type.id} value={type.value}>
                      {type.name}
                    </option>
                  ))}
                </Form.Control>

                {!questionRow.type ? (
                  <Form.Control
                    type="text"
                    readOnly
                    className="custom-col-1-5 am-question"
                    size="sm"
                    placeholder="--Response Options--"
                  />
                ) :
                  questionRow.type === "MultiSelect" ? (
                    <Accordion
                      defaultActiveKey={this.state.activeAccordion}
                      className="custom-col-1-5 am-padding"
                      onClick={() =>
                        this.saveId(index + 1, questionRow.isEditable)
                      }
                    >
                      <Card className="radius accordion-height custom-width">
                        <Accordion.Toggle
                          as={Card.Header}
                          eventKey="0"
                          className="noColor cardHead "
                        >
                          {Object.keys(questionRow.options).length
                            ? this.add3Dots(
                              Object.values(questionRow.options),
                              30
                            )
                            : "Click here to add options"}{" "}
                          <i className="fas fa-chevron-down downIcon"></i>
                        </Accordion.Toggle>

                        <Accordion.Collapse
                          eventKey="0"
                          id={index + 1}
                          className={"am-option-accordion"}
                        >
                          <Card.Body className="cardBodyStyle noColor">
                            <Form className="optionsForm">
                              {questionRow.isEditable ? (
                                ""
                              ) : (
                                <Form.Row className="mb-2">
                                  <Col
                                    md={{ span: 3, offset: 9 }}
                                    className="text-center"
                                  >
                                    <a
                                      onClick={() =>
                                        this.addQuestionOptions(index)
                                      }
                                    >
                                      <i className="fa fa-plus"></i>&nbsp; Add
                                    </a>
                                  </Col>
                                </Form.Row>
                              )}
                              {Object.keys(questionRow.options).map((k) => {
                                return (
                                  <Form.Row key={k} className="am-options">
                                    <Col md={10}>
                                      <Form.Control
                                        type="text"
                                        value={questionRow.options[k]}
                                        disabled={
                                          questionRow.isEditable ? true : false
                                        }
                                        onChange={(e) =>
                                          this.updateOptionsValue(e, index, k)
                                        }
                                        maxLength={this.state.textMaxLength}
                                      ></Form.Control>
                                    </Col>
                                    {questionRow.isEditable ? (
                                      ""
                                    ) : (
                                      <Col md={2}>
                                        <span
                                          className="delete-style am-questions"
                                          onClick={() =>
                                            this.handleDeleteOption(index, k)
                                          }
                                        >
                                          <img
                                            src="/Images/ico-delete.png"
                                            alt="delete-icon"
                                            className="image-padding"
                                          />
                                        </span>
                                      </Col>
                                    )}
                                  </Form.Row>
                                );
                              })}
                            </Form>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  ) : questionRow.type === "Y/N" ? (
                    <Form.Control
                      as="select"
                      className="custom-col-1-5 am-question"
                      size="sm"
                    >
                      {CommonService.yesNoOption.map((type) => (
                        <option key={type.id} value={type.value}>
                          {type.name}
                        </option>
                      ))}
                    </Form.Control>
                  ) : (
                    <Form.Control
                      type="text"
                      readOnly
                      className="custom-col-1-5 am-question"
                      size="sm"
                    ></Form.Control>
                  )}

                <Form.Control
                  as="select"
                  name="weightage"
                  size="sm"
                  placeholder="Choose criticality type"
                  className="custom-col-1-5 am-question"
                  disabled={questionRow.isEditable ? true : false}
                  value={questionRow.weightage ? questionRow.weightage : ""}
                  onChange={(e) => this.updateQuestion(false, index, e)}
                >
                  {CommonService.weightage.map((val) => (
                    <option
                      key={val.id}
                      value={val.value}
                      disabled={val.value === ""}
                      hidden={val.value === ""}
                    >
                      {val.name}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control
                  type="number"
                  name="numberInput"
                  size="sm"
                  placeholder="--Weightage--"
                  className="custom-col-1-5 am-question"
                  disabled={questionRow.isEditable ? true : false}
                  value={
                    questionRow.numericWeightage
                      ? questionRow.numericWeightage
                      : ""
                  }
                  onChange={(e) => this.updateQuestion(false, index, e)}
                  min={0}
                  max={100}
                  step={1}
                ></Form.Control>
                <Form.Control
                  as="select"
                  name="questionSectionType"
                  size="sm"
                  placeholder="Choose Question type"
                  className="custom-col-1-5 am-question"
                  disabled={questionRow.isEditable ? true : false}
                  value={questionRow.questionSectionType ? questionRow.questionSectionType : ""}
                  onChange={(e) => this.updateQuestion(false, index, e)}
                >
                  {CommonService.questionSectionType.map((val) => (
                    <option
                      key={val.id}
                      value={val.value}
                      disabled={val.value === ""}
                      hidden={val.value === ""}
                    >
                      {val.name}
                    </option>
                  ))}
                </Form.Control>
                {/* { !this.props.questionSetEditMode ? ''

                    : this.state.isEditClick ? <div className="noPadding text-center icon-color"> */}
                {/* <span className='am-question' onClick={() => this.handleSubmitQuestion(index, questionRow)} > */}
                {/* <img src="/Images/ico-approve.png" className="add-btn-icon" alt='Amgen' /> */}
                {/* <span className='am-question' onClick={() => this.handleAddQuestion(index)} >
                         <i className="fa fa-lg fa-plus-circle" aria-hidden="true"></i>
                         </span>
                      { this.state.scorecardQuestionDetails.length > 1 ? <span className='delete-style am-question' onClick={() => this.deletePopup(index, questionRow)} > <img src="/Images/ico-delete.png" className="add-btn-icon" alt='Amgen' /></span> : '' }
                    </div>
                      : */}
                {this.state.isQuestionNew ? (
                  <div className="noPadding text-center icon-color">
                    <span
                      className="am-question"
                      onClick={() => this.handleAddQuestion(index)}
                    >
                      <i
                        className="fa fa-lg fa-plus-circle"
                        aria-hidden="true"
                      ></i>
                      {/* <img src="/Images/ico-edit.png" className="add-btn-icon" alt='Amgen' /> */}
                    </span>
                    {this.state.scorecardQuestionDetails.length > 1 ? (
                      <span
                        className="delete-style am-question"
                        onClick={() => this.deletePopup(index, questionRow)}
                      >
                        {" "}
                        <img
                          src="/Images/ico-delete.png"
                          className="add-btn-icon"
                          alt="Amgen"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  " "
                )}
              </div>
            );
          })}
          <div className="row">
            <div className="score-card-total col-md-12">
              <Row>
                <Col sm={10}>Total Weightage<span class="tooltip-container"><img src="/Images/ico-info-filled.png" alt="Info" class="hint-icon" /><span class="tooltip-text">Questions weightage must add up to 100%</span></span></Col>
                <Col>
                  {Array.isArray(this.state.numericWeightage)
                    ? this.state.numericWeightage.reduce((a, b) => a + b, 0)
                    : 0}{" "}
                  %
                </Col>
              </Row>
              <Row>
                <Col sm={2}>Passing Score</Col>
                {/* <Col>
                <input
                  type="range"
                  min={0}
                  max={100}
                  step={1}
                  value={this.state.thresholdValue}
                  disabled={a[0]}
                  onChange={(e) =>
                    this.setState({ thresholdValue: e.target.value })
                  }
                />
                <Form.Text
                  className="text-muted"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  Value:{" "}
                  <strong
                    style={{
                      fontSize: "1rem",
                    }}
                    className="fs-1 rounded"
                  >
                    {this.state.thresholdValue}
                  </strong>
                </Form.Text>
              </Col> */}
                <Col>
                  <div className="plus-min">
                    {!a[0] && (
                      <span
                        className="plus-min-box minus"
                        onClick={() => this.percentExtract("minus")}
                      >
                        -
                      </span>
                    )}
                    {!a[0] ? (
                      <span className="plus-min-box percent">
                        <input
                          type="text"
                          className={
                            this.state.thresholdValue > 99
                              ? "percentStyle t-width"
                              : this.state.thresholdValue > 9
                                ? "percentStyle d-width"
                                : "percentStyle"
                          }
                          value={this.state.thresholdValue}
                          onChange={this.handleOnChangeInput1}
                        />
                      </span>
                    ) : (
                      this.state.thresholdValue
                    )}
                    {!a[0] && (
                      <span
                        className="plus-min-box plus"
                        onClick={() => this.percentExtract("plus")}
                      >
                        +
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

            </div>
          </div>
          <div className="row">
            <div className="col-md-4 offset-md-8 text-center">
              <div className="row">
                <button
                  className="mt-4 clear follow-up-back mr-2 btn btn-secondary"
                  onClick={this.goBack}
                >
                  <img
                    src="Images/icon-arrow-left.png"
                    className="back_btn"
                    alt="Amgen"
                  />
                  Back
                </button>

                {/* {this.props.questionSetEditMode ? <button className="mt-4 p-2 button-color btn-extract col-md-4" onClick={this.handleAddQuestion}><span>Add Question</span></button>
                : ''} */}
                {this.props.questionSetEditMode ? (
                  this.state.isQuestionNew ? (
                    <button
                      className="mt-4 p-2 button-color btn-extract col-md-4"
                      onClick={this.handleSubmitQuestion.bind(this)}
                    >
                      <span>Save</span>
                    </button>
                  ) : (
                    <>
                      {!this.state.isSubmit ? (
                        <button
                          className="mt-4 p-2 button-color btn-extract col-md-3"
                          onClick={this.handleEditQuestion.bind(this)}
                        >
                          <span>Edit</span>
                        </button>
                      ) : (
                        <button
                          className="mt-4 p-2 button-color btn-extract col-md-4"
                          onClick={this.handleEditQuestion.bind(this)}
                        >
                          <span>Edit</span>
                        </button>
                      )}
                      {!this.state.isSubmit ? (
                        <button
                          className="mt-4 p-2 button-color btn-extract col-md-3"
                          onClick={this.clonePopup.bind(this)}
                        >
                          <span>Clone</span>
                        </button>
                      ) : (
                        <></>
                      )}
                    </>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <PopupModels
            showPopup={this.state.questionariesSuccessModel}
            iconFlag="success"
            message={
              this.state.isEditQuestionsetSuccess
                ? MessageConstant.EDIT_QUESTIONSET
                : this.state.isEdit
                  ? MessageConstant.ADD_QUESTIONARIES
                  : this.state.isDelete
                    ? MessageConstant.DELETE_QUESTIONARIES
                    : MessageConstant.EDIT_QUESTIONARIES
            }
            handleClosePopup={this.handlePopupClose}
          />
          <PopupModels
            showPopup={this.state.extractValidation}
            iconFlag="error"
            message={this.state.extractErrMsg}
            handleClosePopup={this.handleExtractValidationClose.bind(this)}
          />
          <ConfirmationModal
            showModal={this.state.showDeleteConfirmation}
            handleCloseModal={this.hideDeletePopup.bind(this)}
            message={MessageConstant.QUESTIONARIE_DELETE_CONFIRMATION}
            navigate={() => {
              this.handleDeleteQuestion(
                this.state.qid,
                this.state.questionDetail
              );
            }}
          />
          <ConfirmationModal
            showModal={this.state.showCloneConfirmation}
            handleCloseModal={this.hideClonePopup.bind(this)}
            message={MessageConstant.QUESTIONSET_CLONE_CONFIRMATION}
            navigate={() => {
              this.handleCloneQuestion();
            }}
          />
          <Modal show={this.state.showModal} onHide={this.hideModal}>
            <Modal.Header closeButton>
              <Modal.Title>Message to User</Modal.Title>
            </Modal.Header>
            {this.state.modalMessage && (
              <Modal.Body>{this.state.modalMessage}</Modal.Body>
            )}
            <Modal.Footer>
              <Button onClick={this.hideModal}>Close</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

EditScorecardQuestionaries.propTypes = {
  questionDetails: PropTypes.object,
  hideViewDetails: PropTypes.func,
  questionSetEditMode: PropTypes.bool,
  scorecardQuestionDetails: PropTypes.array,
  isQuestionNew: PropTypes.bool,
  isEditable: PropTypes.bool,
};

export default EditScorecardQuestionaries;